<div class="container mt-5">
  <div *ngIf="periodTrackerContent">
    
    <div [innerHTML]="periodTrackerContent.body"></div>
  </div>
  <app-download-section></app-download-section>
</div>